import {
  REGISTER_USER,
  REGISTER_USER_SUCCESSFUL,
  REGISTER_USER_FAILED,
  SET_USER_TO_BE_CREATED,
  SET_CAMPAIGNS_TO_BE_CREATED,
  CREATE_REGISTRATION_PENDING_USER,
  CREATE_REGISTRATION_PENDING_USER_SUCCESS,
  CREATE_REGISTRATION_PENDING_USER_FAILURE,
  GET_REGISTRATION_PENDING_USER_BY_ID,
  GET_REGISTRATION_PENDING_USER_BY_ID_SUCCESS,
  GET_REGISTRATION_PENDING_USER_BY_ID_ERROR,
} from "./actionTypes"


export const setUserToBeCreated = (user, history) => {
  return {
    type: SET_USER_TO_BE_CREATED,
    payload: { user, history },
  }
}

export const setCampaignsToBeCreated = (campaign) => {
  return {
    type: SET_CAMPAIGNS_TO_BE_CREATED,
    payload: campaign,
  }
}

export const registerUser = (user_details, history, new_stripe_setup=false) => {
  return {
    type: REGISTER_USER,
    payload: { user_details, history, new_stripe_setup},
  }
}

export const registerUserSuccessful = user => {
  return {
    type: REGISTER_USER_SUCCESSFUL,
    payload: user,
  }
}

export const registerUserFailed = user => {
  return {
    type: REGISTER_USER_FAILED,
    payload: user,
  }
}

export const createRegistrationPendingUser = (payload) => {
  return {
    type: CREATE_REGISTRATION_PENDING_USER,
    payload: payload
  }
}

export const createRegistrationPendingUserSuccess = (payload) => {
  return {
    type: CREATE_REGISTRATION_PENDING_USER_SUCCESS,
    payload: payload
  }
}

export const createRegistrationPendingUserFailure = (error) => {
  return {
    type: CREATE_REGISTRATION_PENDING_USER_FAILURE,
    payload: error
  }
}

export const getRegistrationPendingUserById = (payload) => {
  return {
    type: GET_REGISTRATION_PENDING_USER_BY_ID,
    payload: payload
  }
}

export const getRegistrationPendingUserByIdSuccess = (payload) => {
  return {
    type: GET_REGISTRATION_PENDING_USER_BY_ID_SUCCESS,
    payload: payload
  }
}

export const getRegistrationPendingUserByIdError = (error) => {
  return {
    type: GET_REGISTRATION_PENDING_USER_BY_ID_ERROR,
    payload: error
  }
}
